import { UserOutlined } from '@ant-design/icons'
import AppButton from '../../components/AppButton'
import HeaderSection from '../../components/HeaderSection'
import AppLayout from '../layout/AppLayout'
import { useHistory } from 'react-router-dom';
import { Form, FormInstance, Input, message, Space } from 'antd';
import React from 'react';
import AppCard from '../../components/AppCard';
import SectionContent from '../../components/SectionContent';
import { generateFormRules } from '../../helpers/formRules';
import { IChangePassword } from '../../types/user.type';
import useAuth from '../../hooks/useAuth';
import { getErrorMessage } from '../../helpers/errorHandler';
import axios from 'axios';

const ChangeMyPassword: React.FC = () => {
  const history = useHistory()
  const formRef =
    React.useRef<FormInstance<IChangePassword>>(
      null
    );

  const { user, token, logout } = useAuth()
  const [isLoading, setIsLoading] = React.useState(false)

  const handleSave = (values: IChangePassword) => {
    if (values.newPassword !== values.retypePassword) {
      message.error('New Password and Retype Password is not same. Please check!')
    } else {
      setIsLoading(true);
      axios.post('/auth/change-password/old-password', {
        email: user.email,
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
      }, {
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(() => {
        message.success('Password updated succesfully. Please re-login.')
        setIsLoading(false)
        
        logout()
      }).catch(err => {
        setIsLoading(false)
        message.error('Failed. ' + getErrorMessage(err))
        formRef.current?.resetFields()
      })
    }
  }
  const handleCancel = () => {
    history.push('/profile')
  }

  return (
    <AppLayout>
      <HeaderSection
        icon={<UserOutlined />}
        title="Change Password"
        subtitle="Manage your password"
        rightAction={
          <Space>
            <AppButton onClick={handleCancel}>Cancel</AppButton>
            <AppButton
              loading={isLoading}
              type="primary"
              onClick={() => formRef?.current?.submit()}
            >
              Save
            </AppButton>
          </Space>
        }
      />

      <AppCard loading={isLoading}>
        <Form
          ref={formRef}
          name="passwordForm"
          layout="vertical"
          onFinish={handleSave}
          initialValues={{
            oldPassword: '',
            newPassword: '',
            retypePassword: ''
          }}
          autoComplete="off"
        >
          <SectionContent
            groupTitle="Password Data"
            helpers={[
              {
                title: 'Information',
                content:
                  'Password minimum 8 characters (letter, number and special character)',
              },
            ]}
          >
            <Form.Item
              label="Old Password"
              name="oldPassword"
              rules={generateFormRules('Old Password', [
                'required',
              ])}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label="New Password"
              name="newPassword"
              rules={generateFormRules('Old Password', [
                'required',
                'password'
              ])}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              label="Retype Password"
              name="retypePassword"
              rules={generateFormRules('Old Password', [
                'required',
                'password'
              ])}
            >
              <Input.Password />
            </Form.Item>
          </SectionContent>
        </Form>
      </AppCard>
    </AppLayout>
  );
}

export default ChangeMyPassword